/* base URL for all backend requests - same-origin '/api' by default
(CloudFront routes /api/* to the Lambda backend in production, and the CRA dev
server proxies /api to localhost:5001 in development - see "proxy" in package.json)

REACT_APP_API_URL can override this at build time if the API ever lives on a different origin */

export const API_BASE = process.env.REACT_APP_API_URL || '/api';
